<div class="chart-shell" [style.height.px]="height">
  <canvas
    baseChart
    #chart="base-chart"
    [type]="chartType"
    [data]="chartDataConfig"
    [options]="chartOptions"
    [plugins]="chartPlugins"
  >
  </canvas>
</div>
